/**
 * Load script tag and resolve as a promise
 */

import { isString } from "@mcwd/typescript-type-guards";

// this function will work cross-browser for loading scripts asynchronously
export function loadScriptAsPromise(
  srcOrOptions: string | { src: string, async?: boolean, crossOrigin?: string }
): Promise<HTMLScriptElement> {
  const { src, async = true, crossOrigin = null } = isString(srcOrOptions) ? { src: srcOrOptions } : srcOrOptions;
  return new Promise<HTMLScriptElement>((resolve: (val: HTMLScriptElement) => void, reject: (reason: any) => void) => {
    const s: HTMLScriptElement = document.createElement("script");
    s.type = "text/javascript";
    s.src = src;
    s.async = async;
    if (crossOrigin) { s.crossOrigin = crossOrigin; }
    s.onerror = reject;
    s.onload = () => {
      resolve(s);
    };
    const scripts = document.getElementsByTagName("script");
    if (scripts.length > 0) {
      const firstScript = scripts[0];
      if (firstScript.parentElement) {
        firstScript.parentElement.insertBefore(s, firstScript);
        return;
      }
    }
    document.head.appendChild(s);
  });
}
